(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-button"] && !Shopify.designMode) return;
  try {
    if (!window.__syreboDirectCheckoutDelegated) {
    window.__syreboDirectCheckoutDelegated = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-syrebo-direct-checkout]');

      if (!button || button.disabled) return;

      const form = button.closest('form');
      const paymentWrapper = button.closest('.productView-payment');
      const status = form?.querySelector('[data-syrebo-direct-checkout-status]');

      if (!form || paymentWrapper?.hasAttribute('disabled')) return;

      button.disabled = true;
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');

      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const responseBody = await response.json().catch(() => ({}));

        if (!response.ok || responseBody.status) throw new Error(responseBody.description || button.dataset.errorMessage);

        window.location.assign(button.dataset.checkoutUrl);
      } catch (error) {
        if (status) {
          status.textContent = button.dataset.errorMessage;
          status.hidden = false;
        }

        button.disabled = false;
        button.classList.remove('loading');
        button.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syrebo-product-discount-code"] && !Shopify.designMode) return;
  try {
    if (!window.syreboDiscountCopyReady) {
    window.syreboDiscountCopyReady = true;

    document.addEventListener('click', async function (event) {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-syrebo-discount-copy]');
      if (!button) return;

      const code = button.dataset.discountCode;
      const label = button.querySelector('[data-syrebo-copy-label]');
      const container = button.closest('[data-syrebo-product-discount]');
      const status = container.querySelector('[data-syrebo-copy-status]');
      let copied = false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch (error) {
        copied = false;
      }

      if (!copied) {
        const field = document.createElement('textarea');
        field.value = code;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        copied = document.execCommand('copy');
        field.remove();
      }

      const message = copied ? button.dataset.copiedLabel : button.dataset.errorLabel;
      label.textContent = message;
      status.textContent = message;

      window.setTimeout(function () {
        label.textContent = button.dataset.copyLabel;
        status.textContent = '';
      }, 2000);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syrebo-product-video-support"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.getElementById('syrebo-video-support-template');
    const main = document.getElementById('MainContent');
    if (!template || !main) return;
    const records = new Map();
    const watched = new WeakSet();
    const externalRoots = '#halo-video-popup, .fancybox-container';

    function enhance(frame) {
      if (records.has(frame)) return;
      let url;
      try { url = new URL(frame.getAttribute('src'), location.origin); } catch (_) { return; }
      if (!/^(www\.)?youtube(-nocookie)?\.com$/.test(url.hostname)) return;
      const match = url.pathname.match(/^\/embed\/([A-Za-z0-9_-]{11})$/);
      if (!match) return;
      const original = frame.getAttribute('src');
      const hadPolicy = frame.referrerPolicy === 'strict-origin-when-cross-origin';
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.allowFullscreen = true;
      if (!frame.hasAttribute('allow')) frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      if (!frame.title) frame.title = 'YouTube';

      const controls = template.content.firstElementChild.cloneNode(true);
      controls.querySelector('a').href = 'https://www.youtube.com/watch?v=' + match[1];
      const start = url.searchParams.get('start');
      if (start && /^\d+$/.test(start)) controls.querySelector('a').href += '&t=' + start + 's';
      const retry = controls.querySelector('button');
      if (template.hasAttribute('data-target-videos')) retry.textContent = template.dataset.alternativeLabel;
      retry.addEventListener('click', () => {
        const status = controls.querySelector('[role="status"]');
        if (template.hasAttribute('data-target-videos')) {
          const alternative = new URL(frame.src);
          alternative.hostname = alternative.hostname === 'www.youtube-nocookie.com' ? 'www.youtube.com' : 'www.youtube-nocookie.com';
          alternative.searchParams.set('autoplay', '1');
          frame.src = alternative.href;
          status.textContent = template.dataset.alternativeStatus;
        } else {
          frame.setAttribute('src', frame.getAttribute('src'));
          status.textContent = status.dataset.retryMessage;
        }
      });

      const demo = frame.closest('.c10-saebo-demo');
      const stage = frame.closest('.c10-saebo-dialog__video, .e12-saebo-media-modal__stage, .fancybox-content, .halo-popup-content');
      const gallery = frame.closest('.productView-video');
      if (demo) {
        const copy = demo.querySelector('.c10-saebo-demo__copy');
        const originalLink = copy.querySelector('a[href*="youtube.com/watch"]');
        if (originalLink) originalLink.replaceWith(controls);
        else copy.append(controls);
      } else if (stage) {
        stage.after(controls);
      } else if (gallery) {
        gallery.after(controls);
      } else {
        frame.classList.add('syrebo-video-responsive');
        frame.after(controls);
      }
      records.set(frame, controls);
      if (!gallery && !stage && !hadPolicy) frame.setAttribute('src', original);
    }

    function scan(root) {
      if (root.matches?.('iframe')) enhance(root);
      root.querySelectorAll?.('iframe').forEach(enhance);
    }
    function cleanup() {
      records.forEach((controls, frame) => {
        if (!frame.isConnected) { controls.remove(); records.delete(frame); }
      });
    }
    function watch(root) {
      if (watched.has(root)) return;
      watched.add(root);
      scan(root);
      new MutationObserver(changes => {
        changes.forEach(change => {
          if (change.type === 'attributes') {
            const frame = change.target;
            const controls = records.get(frame);
            if (controls && controls.querySelector('a').href.split('v=')[1]?.split('&')[0] !== frame.getAttribute('src')?.split('/embed/')[1]?.split('?')[0]) {
              controls.remove(); records.delete(frame);
            }
            enhance(frame);
          } else change.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
        });
        cleanup();
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
    watch(main);
    document.querySelectorAll(externalRoots).forEach(watch);
    new MutationObserver(changes => {
      changes.forEach(change => change.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches(externalRoots)) watch(node);
        node.querySelectorAll(externalRoots).forEach(watch);
      }));
      cleanup();
    }).observe(document.body, { childList: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["syrebo-title-details"] && !Shopify.designMode) return;
  try {
    (() => {
  const pageRoot = document.documentElement;

  if (!pageRoot.dataset.syreboGallerySyncBound) {
    pageRoot.dataset.syreboGallerySyncBound = 'true';

    const handledGalleryEvents = new WeakSet();
    const handleGalleryThumbnailClick = (event) => {
      const clickTarget = event.target;
      if (!clickTarget || typeof clickTarget.closest !== 'function') return;

      const thumbnailLink = clickTarget.closest('.productView-for .productView-thumbnail a');
      if (!thumbnailLink) return;
      if (handledGalleryEvents.has(event)) return;

      handledGalleryEvents.add(event);

      const thumbnail = thumbnailLink.closest('.productView-thumbnail');
      const galleryScope = thumbnail.closest('.halo-productView-left');
      const galleryNav = galleryScope?.querySelector('.productView-nav');
      const dotButtons = galleryScope?.querySelectorAll('.productView-nav .slick-dots button');
      const rawIndex = Number(thumbnail.dataset.slickIndex);

      if (!galleryNav || !dotButtons?.length || !Number.isFinite(rawIndex)) return;

      const targetIndex = ((rawIndex % dotButtons.length) + dotButtons.length) % dotButtons.length;

      requestAnimationFrame(() => {
        const slickLibrary = window.jQuery || window.$;

        if (typeof slickLibrary === 'function' && typeof slickLibrary(galleryNav).slick === 'function') {
          slickLibrary(galleryNav).slick('slickGoTo', targetIndex);
          return;
        }

        const previousButton = galleryNav.querySelector('.slick-prev');
        const nextButton = galleryNav.querySelector('.slick-next');

        if (previousButton && nextButton) {
          let attempts = 0;

          const advanceToTarget = () => {
            const currentSlide = galleryNav.querySelector('.slick-slide.slick-current:not(.slick-cloned)');
            const currentIndex = Number(currentSlide?.dataset.slickIndex);

            if (!Number.isFinite(currentIndex) || currentIndex === targetIndex || attempts >= dotButtons.length) return;

            const forwardSteps = (targetIndex - currentIndex + dotButtons.length) % dotButtons.length;
            const backwardSteps = (currentIndex - targetIndex + dotButtons.length) % dotButtons.length;

            if (forwardSteps <= backwardSteps) {
              nextButton.click();
            } else {
              previousButton.click();
            }

            attempts += 1;
            window.setTimeout(advanceToTarget, 380);
          };

          advanceToTarget();
          return;
        }

        dotButtons[targetIndex]?.click();
      });
    };

    window.addEventListener('click', handleGalleryThumbnailClick, true);
    document.querySelectorAll('.productView-for .productView-thumbnail a').forEach((thumbnailLink) => {
      thumbnailLink.addEventListener('click', handleGalleryThumbnailClick, true);
    });
  }

  const dockMobileChat = () => {
    const chatHost = document.querySelector('shopify-chat');
    const chatRoot = chatHost?.shadowRoot;
    if (!chatRoot) return false;

    const ensureChatStyle = () => {
      if (chatRoot.querySelector('style[data-syrebo-chat-dock]')) return;

      const chatStyle = document.createElement('style');
      chatStyle.dataset.syreboChatDock = 'true';
      chatStyle.textContent = '@media (max-width: 749px) { :host .activator-nudge { display: none !important; } }';
      chatRoot.append(chatStyle);
    };

    ensureChatStyle();

    if (!chatHost.dataset.syreboChatDockWatching) {
      chatHost.dataset.syreboChatDockWatching = 'true';
      new MutationObserver(ensureChatStyle).observe(chatRoot, { childList: true });
    }

    return true;
  };

  dockMobileChat();

  let chatAttempts = 0;
  const chatObserver = new MutationObserver(dockMobileChat);

  chatObserver.observe(document.documentElement, { childList: true, subtree: true });

  const chatTimer = window.setInterval(() => {
    chatAttempts += 1;
    dockMobileChat();

    if (chatAttempts >= 120) {
      window.clearInterval(chatTimer);
      chatObserver.disconnect();
    }
  }, 250);
})();
  } catch(e) { console.error(e); }
})();

})();
